import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>Renewal Requirements</PageTitle>
    <p>Please confirm that all the below requirements have been met.</p>
  </div>
);
